// extracted by mini-css-extract-plugin
export default {"dropbtn":"Navbar_dropbtn__mE34c","dropdown":"Navbar_dropdown__nnUL3","dropdown_content":"Navbar_dropdown_content__zS3t8"};